var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.storeInfo.store_baozh)?_c('div',{staticClass:"main-content"},[_c('flex-line',{attrs:{"is-link":true,"show-border":true},nativeOn:{"click":function($event){return _vm.changeTranslateState()}}},[_c('span',[_vm._v("保障")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }